<div class="brand-header">
  <ng-container *ngIf="data.logo">
    <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
  </ng-container>
  <div class="brand-details">
    <h1>{{ data.companyName | camelcase}}</h1>
    <ng-container *ngIf="data.url">
      <a class="data-url" (click)="sanitizeUrl(data.url); $event.preventDefault();"
      rel="noopener noreferrer">
       {{ data.url }}
      </a>
    </ng-container>
  </div>
</div>

<h1 class="send-enquiry-banner" style="background-color:  #0D87C8;  margin: 0; margin-top: 29px; margin-left: 20px; margin-bottom: 29px; margin-right: 29px;
 color: #fff; font-size: 16px; font-weight: 400;padding:4px;border-radius: 8px;padding-left: 10px; font-family: 'work sans';">
  <img src="../../../../../assets/images/send-enquiry-icon.svg" width="24px" height="24px" style="margin: 0 8px;"> Send Enquiry</h1>

<div class="container contactOverallContainer ipadCardSizeFit">
    <div class="card formCard" style="margin-left: 29px; max-height: 436px;">
      <div class="card-body">
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
            <input type="text" id="name" class="form-control" formControlName="name" placeholder="Enter Here" [ngClass]="{'is-invalid': isNameInvalid}" alphabetOnly>
            <mat-error class="error-message error-msg" *ngIf="isNameInvalid">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Name is Required
            </mat-error>
          </div>

          <div class="row mb-3">
            <div class="col-md-6 emailContainer">
              <label for="email" class="form-label">Email Address<span class="text-danger">*</span></label>
              <input type="email" id="email" placeholder="Enter Here" class="form-control" formControlName="email" >               <!-- [ngClass]="{'is-invalid': isEmailInvalid}" -->
              <mat-error class="error-message error-msg" *ngIf="(submitted && isEmailError) || ((enquiryForm.get('email')?.dirty || enquiryForm.get('email')?.touched) && !enquiryForm.get('email')?.value)">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Email is Required
              </mat-error>
              <mat-error class="error-message error-msg" *ngIf="enquiryForm.get('email')?.invalid && enquiryForm.get('email')?.value">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Enter valid email
              </mat-error>
            </div>

            <div class="col-md-6" *ngIf="!ipadViewForPhoneField">
              <label for="phone" class="form-label">Phone Number<span class="text-danger">*</span></label>
              <div class="input-group" style="display: flex; align-items: center; position: relative;">

                <!-- Search and Select Input Field (Country Code) -->
                <input
                  type="text"
                  placeholder="IN"
                  [formControl]="searchControl"
                  (focus)="showDropdownList()"
                  (input)="filterCountryCodes(searchControl.value || '')"
                  (blur)="hideDropdown()"
                  class="form-control country-input"
                />

                <!-- Custom Dropdown -->
                <div class="dropdown-menu" [ngClass]="{'show': showDropdown}" style="position: absolute; top: 100%; left: 0; width: 100%; z-index: 1000;">
                  <button
                    class="dropdown-item"
                    *ngFor="let code of filteredCountryCodes"
                    (mousedown)="selectCountryCode(code)"
                  >
                    {{ code.countryCode | uppercase }}
                  </button>
                </div>

                <!-- Phone Code Input (Automatically updated) -->
                <input type="text" class="form-control phone-code-input" placeholder="+91" formControlName="phoneCode" readonly required>

                <!-- Phone Number Input -->
                <input type="text" class="form-control phone-number-input" placeholder="Enter Here" formControlName="phone" title="Enter a valid mobile number" minlength="5" maxlength="15" required>
              </div>

              <!-- Validation Error Messages -->
              <mat-error class="error-message" *ngIf="enquiryForm.get('phoneCode')?.invalid && enquiryForm.get('phoneCode')?.touched">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Country Code is required.
              </mat-error>

              <!-- Validation Error Messages for Phone Number -->
              <mat-error class="error-message" *ngIf="phone?.hasError('required') && phone?.touched">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is required.
              </mat-error>
              <mat-error class="error-message" *ngIf="phone?.hasError('minlength') && phone?.touched">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number should be at least 5 digits long.
              </mat-error>
              <mat-error class="error-message" *ngIf="phone?.hasError('maxlength') && phone?.touched">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number should not exceed 15 digits.
              </mat-error>
            </div>
          </div>
          <div class="mb-3 phoneIpadContainer" *ngIf="ipadViewForPhoneField">
            <label for="phone" class="form-label">Phone Number<span class="text-danger">*</span></label>
            <div class="input-group" style="display: flex; align-items: center; position: relative;">

              <!-- Search and Select Input Field (Country Code) -->
              <input
                type="text"
                placeholder="IN"
                [formControl]="searchControl"
                (focus)="showDropdownList()"
                (input)="filterCountryCodes(searchControl.value || '')"
                (blur)="hideDropdown()"
                class="form-control country-input"
              />

              <!-- Custom Dropdown -->
              <div class="dropdown-menu" [ngClass]="{'show': showDropdown}" style="position: absolute; top: 100%; left: 0; width: 100%; z-index: 1000;">
                <button
                  class="dropdown-item"
                  *ngFor="let code of filteredCountryCodes"
                  (mousedown)="selectCountryCode(code)"
                >
                  {{ code.countryCode | uppercase }}
                </button>
              </div>

              <!-- Phone Code Input (Automatically updated) -->
              <input type="text" class="form-control phone-code-input" placeholder="+91" formControlName="phoneCode" readonly required>

              <!-- Phone Number Input -->
              <input type="text" class="form-control phone-number-input" placeholder="Enter Here" formControlName="phone" title="Enter a valid mobile number" minlength="5" maxlength="15" required>
            </div>

           <div class="phoneMatError">
             <!-- Validation Error Messages -->
             <mat-error class="error-message" *ngIf="enquiryForm.get('phoneCode')?.invalid && enquiryForm.get('phoneCode')?.touched">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Country Code is required.
            </mat-error>

            <!-- Validation Error Messages for Phone Number -->
            <mat-error class="error-message" *ngIf="phone?.hasError('required') && phone?.touched">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is required.
            </mat-error>
            <mat-error class="error-message" *ngIf="phone?.hasError('minlength') && phone?.touched">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number should be at least 5 digits long.
            </mat-error>
            <mat-error class="error-message" *ngIf="phone?.hasError('maxlength') && phone?.touched">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number should not exceed 15 digits.
            </mat-error>
           </div>
          </div>
          <div class="mb-3">
            <label for="message" class="form-label">Add Message<span class="text-danger">*</span></label>
            <textarea id="message" class="form-control" formControlName="message" rows="4" placeholder="Enter Here"></textarea>
          </div>

          <div class="d-flex send-enquiry-buttons-div" style="margin-top: 35px;">
            <button type="submit" class="btn send-enquiry">Send Enquiry</button>
            <button type="button" class="btn cancel" (click)="onCancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
    <div class="contact-us-image">
        <div class="card contact-us-image-card d-flex flex-column justify-content-left">
          <div class="card-img ">
            <img src="../../../../../assets/images/brand-contact-us.jpg" width="100%" style="padding: 28px;" height="280px" alt="company logo">
          </div>
          <div class="card-info d-flex flex-column justify-content-start" [class.active]="!isLoggedIn" style="margin: 0 29px;">
            <div class="row address addressContainer" [class.active]="!isLoggedIn" style="overflow: hidden;">
              
              <div class="d-flex flex-row gap-3 full-address" style="max-width: 550px; margin-left: -2px;"[style.overflow-y]="showFull ? 'scroll' : 'hidden'">
                <div class="" ><img src="../../assets/images/icons/location-icon-productpage.svg" class="star"></div>
                <!-- <p class="card-info-address">{{ data.address }} </p></div> -->
                  <p class="card-info-address">
                    <span *ngIf="data.address && !showFull">{{ truncatedAddress }}</span>
                    <span *ngIf="data.address && showFull">{{ data.address }}</span>
                    <span class="toggle-text" *ngIf="data.address && data.address.length > truncatedAddress.length" (click)="toggleView()">{{ showFull ? 'View Less' : 'View More' }}</span>
                  </p>
                </div>
                
                <div class="d-flex flex-row gap-3" style="margin-left: -2px;align-items: center;">
                <div class=""><img  src="../../assets/images/icons/phone-icon-productpage.svg" class="star"></div>
                <p class=" my-2"> {{ data.phoneCode }} {{ data.phoneNumber }}</p></div>
              
                <div class="d-flex flex-row gap-3" style="margin-bottom: 9px; align-items: center;">
                <div class=""><img src="../../assets/images/icons/email-icon-productpage.svg" class="star"></div>
                <p class="emailContact my-2">{{ data.email }}</p></div>
            
            </div>
            <div *ngIf="!isLoggedIn" class="signin" (click)="onLoginPage()">
              <p class="d-flex align-content-center justify-content-center flex-column "> Sign in for more </p>
              <p class="d-flex align-content-center justify-content-center flex-column "> Information </p>
            </div>
        </div>
      </div>
    </div>
    <div class="mapouter" style="margin-left: 29px;" [class.active]="!isLoggedIn">
        <div *ngIf="!isLoggedIn" class="signin" (click)="onLoginPage()">
          <p class="d-flex align-content-center justify-content-center flex-column "> Sign in for more </p>
          <p class="d-flex align-content-center justify-content-center flex-column "> Information </p>
        </div>
      <div class="gmap_canvas" [class.active]="!isLoggedIn">
        <iframe width="500px" height="434px" id="gmap_canvas" [src]="safeUrl" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      </div>
    </div>
</div>
